module.exports = __webpack_public_path__ + "img/banner-1.18e610d1.png";